<div class="logo-container">
    <img class="logo" src="../assets/images/abcis-larger.png" alt="ABCis Logo">
</div>

<div class="main-content-container">
    <module-container>
            <form [formGroup]="passwordForm" class="form-container" (ngSubmit)="resetPassword()">
                <h1>Reset Password</h1>
                <span class="reset-blurb">Please enter in your new password.</span>

                <mat-form-field color="primary"  class="login-input-field" appearance="outline">
                    <mat-label>New Password</mat-label>
                    <input formControlName="newPassword" type="password" (keyup)="validatePasswords()" autocomplete="on" matInput placeholder="Enter your new password">
                </mat-form-field>

                <mat-form-field color="primary"  class="login-input-field" appearance="outline">
                    <mat-label>Confirm Password</mat-label>
                    <input formControlName="confirmPassword" type="password" (keyup)="validatePasswords()" autocomplete="on" matInput placeholder="Confirm your password">
                </mat-form-field>
    
                <form-button type="submit" [formButton]="passwordButton" [isDisabled]="passwordForm.invalid || passwordsInvalid"></form-button>
            </form>
    </module-container>
    <span>Don't want to reset your password?... <a href="Login">click here</a> to return.</span>
</div>